module.exports = __webpack_public_path__ + "static/media/日历8@2x.07914d93.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_145/img/日历8@2x.png
// module id = 1381
// module chunks = 0